import image1 from "../images/gallery/1.jpg";
import image2 from "../images/gallery/2.jpg";
import image3 from "../images/gallery/3.jpg";
import image4 from "../images/gallery/4.jpg";
import image5 from "../images/gallery/5.jpg";
import image6 from "../images/gallery/6.jpg";
import image7 from "../images/gallery/7.jpg";
import image8 from "../images/gallery/a1.jpg";
import image9 from "../images/gallery/a2.jpg";
import image10 from "../images/gallery/a3.jpg";
import image11 from "../images/gallery/a4.jpg";
import image12 from "../images/gallery/a5.jpg";
import image13 from "../images/gallery/a6.jpg";
import image14 from "../images/gallery/a7.jpg";
import image15 from "../images/gallery/a8.jpg";
import image16 from "../images/gallery/a9.jpg";
import image17 from "../images/gallery/a10.jpg";
import image18 from "../images/gallery/a11.jpg";
import image19 from "../images/gallery/a12.jpg";
import image20 from "../images/gallery/b1.jpeg";
import image21 from "../images/gallery/b2.jpeg";
import image22 from "../images/gallery/b3.jpeg";
import image23 from "../images/gallery/b4.jpeg";
import image24 from "../images/gallery/b5.jpeg";
import image25 from "../images/gallery/b6.jpeg";
import image26 from "../images/gallery/b7.jpeg";
import image27 from "../images/gallery/b8.jpeg";
import image28 from "../images/gallery/b9.jpeg";

export const galleryImages = [
    image1,
    image2,
    image21,
    image3,
    image4,
    image20,
    image5,
    image6,
    image22,
    image7,
    image8,
    image23,
    image9,
    image10,
    image24,
    image11,
    image12,
    image25,
    image13,
    image14,
    image26,
    image15,
    image16,
    image27,
    image17,
    image18,
    image19,
    image28,
  ];